import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Let browser handle scroll restoration normally, but override it
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // Function to scroll to top of window
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });

      // Also scroll any scrollable containers with class 'main-content' or similar
      const containers = document.querySelectorAll('.overflow-y-auto, [style*="overflow-y: auto"], [style*="overflow-y:scroll"]');
      containers.forEach((el) => {
        if (el instanceof HTMLElement) {
          el.scrollTop = 0;
        }
      });
    };

    // Scroll immediately
    scrollToTop();

    // Scroll again after React renders
    requestAnimationFrame(() => {
      scrollToTop();
    });

    // And once more after a small delay
    setTimeout(() => {
      scrollToTop();
    }, 150);
  }, [pathname]);

  return null;
}